import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

import { ABTestingMatrix } from "./ab-testing-matrix";

export function useFirebaseRemoteConfig(): useFirebaseRemoteConfigReturn {
  return useLazyContext(FirebaseRemoteConfigContext);
}

export type useFirebaseRemoteConfigReturn = {
  loadABTestingMatrix: () => Promise<ABTestingMatrix>;
};

export const FirebaseRemoteConfigContext =
  createContext<LazyValue<useFirebaseRemoteConfigReturn>>(undefined);
